import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class HotelService {
  constructor(private http: HttpClient, private restService: RestService) {}

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotel/list', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotel/all', val_params);
  }

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotel/search', val_params);
  }

  get(val_id: number) {
    return this.restService.get('hotel/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('hotel/save', data);
  }

  updateSave(data: any) {
    return this.restService.save('hotel/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('hotel/update', val_id, data);
  }

  updateVideo(val_id: number, data: any) {
    return this.restService.update('hotel/update/video', val_id, data);
  }

  saveImage(data: any) {
    return this.restService.save('hotel/save/image', data);
  }

  delete(val_id: number) {
    return this.restService.delete('hotel/delete', val_id);
  }
}
